/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { PERMISSIONS } from '@squiz/dxp-auth';
import { ICON_DASHBOARD, ICON_LOGS, ICON_MONITOR_HEART, NavigationItem } from '@squiz/sds';
import React from 'react';
import { ExperienceMonitoring } from '../Screens/ExperienceMonitoring/ExperienceMonitoring';
import { ExperienceMonitoringPagePreview } from '../Screens/ExperienceMonitoringPagePreview/ExperienceMonitoringPagePreview';
import { Logs } from '../Screens/Logs/Logs';
import { MonitoringDashboard } from '../Screens/MonitoringDashboard/MonitoringDashboard';
import { screenPaths } from './ScreenPaths.constants';
import { MONITORING_STRINGS } from './Strings.constants';

/**
 * Logs screen.
 */
export const LOGS: NavigationItem = {
  icon: ICON_LOGS,
  key: `logs`,
  label: MONITORING_STRINGS.logs,
  path: screenPaths.logs,
  permission: PERMISSIONS.dxpLogging.LOGS_READ,
  screen: <Logs />,
};

/**
 * Monitoring capability home screen.
 */
export const MONITORING_CAPABILITY_DASHBOARD: NavigationItem = {
  devices: [],
  icon: ICON_DASHBOARD,
  key: 'monitoring-dashboard',
  label: MONITORING_STRINGS.dashboard,
  path: screenPaths.monitoringDashboard,
  screen: <MonitoringDashboard />,
};

/**
 * Experience monitoring dashboard screen.
 */
export const EXPERIENCE_MONITORING: NavigationItem = {
  icon: ICON_MONITOR_HEART,
  key: `experience-monitoring`,
  label: MONITORING_STRINGS.experienceMonitoring,
  path: screenPaths.experienceMonitoring,
  screen: <ExperienceMonitoring />,
};

export const EXPERIENCE_MONITORING_PAGE_PREVIEW: NavigationItem = {
  devices: [],
  key: `experience-monitoring-page-preview`,
  label: MONITORING_STRINGS.pagePreview,
  path: screenPaths.experienceMonitoringDomainPage,
  screen: <ExperienceMonitoringPagePreview />,
};
